import { Tooltip } from 'antd';
import http_config from 'common/config/http_config';
import burgeonLogo from 'common/image/burgeon_logo.png';
import { useAuthInfo } from 'features/auth/hooks/useAuthInfo';
import React from 'react';
import { FiActivity, FiCommand, FiUsers, FiVolume2 } from 'react-icons/fi';
import { FaBook } from 'react-icons/fa';
import { SiGoogleclassroom } from 'react-icons/si';
import { BiSupport } from 'react-icons/bi';

import { HiOutlineLogout } from 'react-icons/hi';
import { SidebarItemWrapper, SidebarWrapper } from './sidebar.style';

interface Props {}

const Sidebar: React.FC<Props> = () => {
  const user = useAuthInfo();

  return (
    <SidebarWrapper>
      <header>
        <img src={burgeonLogo} alt="" />
        <p>Burgeon School Enhancer</p>
      </header>

      <section className="user-selected-role">
        <p>School Admin</p>
      </section>

      <section className="user-details">
        <aside className="user-details-left">
          <img src={user.image || http_config.DEFAULT_IMAGE} alt="" />
          <div className="details">
            <p className="name">{user.username}</p>
            <p className="email">{user.email}</p>
          </div>
        </aside>
        <aside className="user-details-right">
          <Tooltip title="Log Out">
            <span className="user-logout">
              <HiOutlineLogout />
            </span>
          </Tooltip>
        </aside>
      </section>

      {user.roles.map((role) => (
        <section className="sidebar-item-list">
          <SidebarItem goto="/dashboard" icon={<FiCommand />} title="Dashboard" />
          <SidebarItem goto="/users" icon={<FiUsers />} title="System Users" />
          <SidebarItem goto="/attendance" icon={<FiActivity />} title="Attendance" />
          <SidebarItem goto="/attendance/staff" icon={<FiActivity />} title="Staff Attendance" />
          <SidebarItem goto="/result" icon={<FiActivity />} title="Result" />
          <SidebarItem goto="/announcement" icon={<FiVolume2 />} title="Announcement" />
          {/* {role.role_code === 555 && ( */}
          <SidebarItem goto="/attendance/support" icon={<BiSupport />} title="Support" />
          {/* )} */}
          <SidebarItem goto="/book" icon={<FaBook />} title="Book" />
          <SidebarItem goto="/routine" icon={<FaBook />} title="Routine" />
          <SidebarItem goto="/examRoutine" icon={<FaBook />} title="Exam Routine" />
          <SidebarItem goto="/subject" icon={<FaBook />} title="Subject" />
          <SidebarItem goto="/class" icon={<SiGoogleclassroom />} title="Class" />

          {/* <SidebarItem goto="/activity" icon={<FiActivity />} title="Activity Logs" /> */}
          {/* <SidebarItem goto="/setting" icon={<FiSettings />} title="System Config" /> */}
        </section>
      ))}
    </SidebarWrapper>
  );
};

interface SidebarItemType {
  icon: any;
  title: string;
  goto: string;
}

const SidebarItem = ({ icon, title, goto }: SidebarItemType) => {
  return (
    <SidebarItemWrapper to={goto} exact activeClassName="active">
      <aside className="left">{icon}</aside>
      <aside className="right">{title}</aside>
    </SidebarItemWrapper>
  );
};

export default Sidebar;
